
export class Transforms {
    static defaultTransform<T>(outputModel: any): T {
        return outputModel as T;
    }
}
